/**
 * ios input 失去焦点时候页面不会滚回的初始位置  解决方法：
 *  */
export const goBottomBackFn = () => {
  setTimeout(() => {
    window.scrollTo(0, document.body.scrollTop + 1)
    document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1)
  }, 10)
}

/**
 * @returns {Object} 获取地址上的参数
 */
export const getUrlParam = (url) => {
  let theRequest = {}
  const str = url.substr(0)
  const strs = str.split('&')
  for (let i = 0; i < strs.length; i++) {
    theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
  }
  return theRequest
}

export const parseUrl2Obj = (url) => {
  let ret = {}
  if (url.indexOf('?') !== -1) {
    url = url.substr(url.indexOf('?') + 1)
    let strs = url.split('&')
    for (let i = 0; i < strs.length; i++) {
      ret[strs[i].split('=')[0]] = (strs[i].split('=')[1])
    }
  }
  return ret
}

/**
 * @returns {Boolean} 判断是否在微信
 */
export const isWeChat = () => {
  let isTure = false
  if (!navigator.userAgent.toLowerCase().match(/micromessenger/i)) {
    isTure = false
  }else {
    isTure = true
  }
  return isTure
}

/*
 *  {token: 1111, userId: 111} 将参数拼接 token=111&userId=111
 */
export const SortParams = data => {
  let param = ''
  for (let i in data) {
    if (param) {
      param += `&${i}=${data[i]}`
    } else {
      param += `${i}=${data[i]}`
    }
  }
  return param
}


// 判断设备类型
export const  getPhoneType = () => {
  let u = navigator.userAgent
  let ver = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
  let result = false
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  if (isAndroid) {
    result = true
  }else {
    ver = parseInt(ver[1], 10)
    if (ver < 13) {
      result = true
    } else {
      result = false
    }
  }
  return result
}

// 判断是否IphoneX
export const getIphoneXType = () => {
  let ua = navigator.userAgent
  let result = false
  console.log('手机型号类型',ua)
  if (ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    console.log('手机型号类型',window.screen.width, window.screen.height)
    if ((window.screen.width === 375 && window.screen.height === 812)
        || (window.screen.width === 375 && window.screen.height === 724)
        || (window.screen.width === 414 && window.screen.height === 896)
        || (window.screen.width === 414 && window.screen.height === 896)
        || (window.screen.width === 390 && window.screen.height === 844)
        || (window.screen.width >= 375 && window.screen.height >= 750)
    ) {
      result = true
    } else {
      result = false
    }
    return result
  }
}

// 时间格式化
export const formatDateUtil = (source, format) => {
  let o = {
    'M+': source.getMonth() + 1, // 月份
    'd+': source.getDate(), // 日
    'H+': source.getHours(), // 小时
    'm+': source.getMinutes(), // 分
    's+': source.getSeconds(), // 秒
    'q+': Math.floor((source.getMonth() + 3) / 3), // 季度
    'f+': source.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (source.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

/**
 * 指定班级是否名额紧张
 * @param  {int}    当前人数
 * @param  {int}    最大人数
 * @return {bool}   是名额紧张
 */
export const isFew = (currentNum, maxNum) => {
  let result = false
  if (currentNum > 0 && maxNum > 0) {
    if (maxNum > 10) {
      if (maxNum - currentNum <= 2 && maxNum - currentNum > 0) {
        result = true
      }
    } else {
      if ((maxNum - currentNum) / (maxNum * 1.0) <= 0.2 && maxNum - currentNum > 0) {
        result = true
      }
    }
  }
  return result
}

// 教学方式
export const teachingMethodUtil = (methodCode) => {
  let iconText = ''
  if (methodCode.length) {
    let methods = methodCode.split(',')
    methods.forEach(val => {
      if (val === '211') {
        iconText += '面授+'
      } else if (val === '223') {
        iconText += '双师+'
      } else if (val === '227') {
        iconText += '录播+'
      } else if (val === '229') {
        iconText += '直播+'
      }else if (val === '233') {
        iconText += '线上+'
      } else if (val === '239') {
        iconText += '智慧学习+'
      }
    })
    if (iconText.length) {
      iconText = iconText.substr(0, iconText.length - 1)
    }
    return iconText
  } else {
    return iconText
  }
}

// 获取课时 - 带小数点
export const getPeriodTimes = (minutes) => {
  if (!minutes) return 0
  let times = (minutes / 60).toFixed(1).toString()

  return Number(times.replace('.0', ''))
}

// 课时，课次
export const getClassLessonTimesUtil = (lessonTimes, realMinutes) => {
  let text = ''
  realMinutes = getPeriodTimes(realMinutes)
  if (lessonTimes > 0 && realMinutes > 0) {
    text = realMinutes + '课时 /' + lessonTimes + '课次'
  } else if (lessonTimes > 0) {
    text = lessonTimes + '课次'
  } else if (realMinutes > 0) {
    text = realMinutes + '课时'
  }
  return text
}

// 住宿班
export const getClassStayUtil = (modeCodes) => {
  let isStay = false
  if (modeCodes.length) {
    if (modeCodes.indexOf('103') !== -1) {
      isStay = true
    }
  }
  return isStay
}

// 名额紧张
export const isFewUtil = (currentNum, maxNum, bmState) => {
  let result = false
  if (bmState < 4 && bmState > 0) {
    if (currentNum > 0 && maxNum > 0) {
      if (maxNum <= 10) {
        if (maxNum - currentNum <= 2 && maxNum - currentNum > 0) {
          result = true
        }
      } else {
        if ((maxNum - currentNum) / (maxNum * 1.0) <= 0.2 && maxNum - currentNum > 0) {
          result = true
        }
      }
    }
  }
  return result
}
